import { render, staticRenderFns } from "./mainfooter.vue?vue&type=template&id=2e24527d&"
import script from "./mainfooter.vue?vue&type=script&lang=js&"
export * from "./mainfooter.vue?vue&type=script&lang=js&"
import style0 from "./mainfooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports